export const ROUTES = [
    {
      name: 'About',
      path: '/about',
      description: 'Information about Prashant Sudeep',
      displayTitle: 'About',
      requiresAuth: false,
      is_hidden: false,
    },
    {
      name: 'ten-percent-trap',
      path: '/ten-percent-trap',
      description: 'Most projects do not fail because the hard part is difficult. They fail because the last ten percent never gets finished.',
      displayTitle: 'The 10% Trap',
      requiresAuth: false,
      is_hidden: false,
    },
    {
      name: 'Advice',
      path: '/advice',
      description: 'The Compounding Life: A Short Guide',
      displayTitle: 'Advice',
      requiresAuth: false,
      is_hidden: false,
    },
    {
      name: 'Blog',
      path: '/blog',
      description: 'Prashant Sudeep\'s blog posts',
      displayTitle: 'Blog',
      requiresAuth: false,
      is_hidden: false,
    },
    {
        name: 'Productive',
        path: '/productive',
        description: 'The Productivity Architecture: A Self-Guide',
        displayTitle: 'Productive',
        requiresAuth: false,
        is_hidden: false,
      },
      {
        name: 'Coding',
        path: '/coding',
        description: 'Why Everyone Should Learn Coding',
        displayTitle: 'Coding',
        requiresAuth: false,
        is_hidden: false,
      },
    {
      name: 'Health',
      path: '/health',
      description: 'Health, nutrition, and long-term wellbeing knowledge base',
      displayTitle: 'Health',
      requiresAuth: false,
      is_hidden: false,
    },
    {
      name: 'AI',
      path: '/ai',
      description: 'Artificial Intelligence knowledge base — concepts, LLMs, and tools',
      displayTitle: 'AI',
      requiresAuth: false,
      is_hidden: false,
    },
    // ... add more routes as needed
    {
        name: 'Notes',
        path: '/n/notes',
        description: 'Personal notes',
        displayTitle: 'My Notes',
        requiresAuth: true,
        is_hidden: false,
    },
    {
        name: 'Secrets',
        path: '/n/secrets',
        description: 'Secrets/password',
        displayTitle: 'Secret Manager',
        requiresAuth: true,
        is_hidden: false,
    },
    {
      name: 'Links',
      path: '/links',
      description: 'Bookmarks',
      displayTitle: 'Bookmarks',
      requiresAuth: false,
      is_hidden: false,
    },
    {
      name: 'Parenting',
      path: '/parenting',
      description: 'Parenting',
      displayTitle: 'Parenting',
      requiresAuth: false,
      is_hidden: true,
    },
    {
      name: 'Write',
      path: '/write',
      description: 'Write something here',
      displayTitle: 'Write',
      requiresAuth: true,
      is_hidden: true,
    },
    {
      name: 'Mental-Junk',
      path: '/mental-junk',
      description: 'Mental Junk',
      displayTitle: 'Write',
      requiresAuth: false,
      is_hidden: true,
    },
    {
      name: 'Archives',
      path: '/archives',
      description: 'My thoughts and writings organized by year and month',
      displayTitle: 'Archives',
      requiresAuth: false,
      is_hidden: false,
    },
    {
      name: 'Admin',
      path: '/admin',
      description: 'Blog administration panel',
      displayTitle: 'Admin',
      requiresAuth: true,
      is_hidden: true,
    }
  ];
  
  export const HOME_ROUTE = {
    name: 'Home',
    path: '/',
    description: 'Prashant Sudeep\'s homepage',
    displayTitle: 'Prashant Sudeep'
  };

  export const LOGIN_ROUTE = {
    name: 'Login',
    path: '/auth/login',
    description: 'Login page',
    displayTitle: 'Login'
  };